/* eslint-disable no-nested-ternary,no-useless-return, no-unneeded-ternary, css-modules/no-unused-class */
import { Icon } from 'common-components';
import React, { useRef, useEffect, useState } from 'react';
import Tooltip from '../../tooltip/tooltip';
import styles from './chipsWrapper.module.scss';

const ChipsWrapper: React.FC<ChipsWrapperProps> = (props: ChipsWrapperProps) => {
    const parentRef = useRef<HTMLDivElement>(null);
    const [renderedItems, setRenderedItems] = useState<JSX.Element[]>([]);
    const {
        itemsText,
        iconName,
        withBorder,
        width,
        icons,
        moreColor,
        fontSize,
        fontColor,
        noStyle,
        iconFirst,
        iconsInTooltip,
        colors,
        padding,
        isListTooltip,
        itemStyle = {},
        itemTitleStyle = {},
        tooltipType = 'secondary'
    } = props;

    const getItemWidth = (item: string) => {
        const div = document.createElement('div');
        div.innerText = item;
        div.style.fontSize = fontSize ? fontSize : withBorder ? '13px' : '11px';
        div.style.position = 'absolute';
        div.style.fontFamily = 'inter';
        div.style.visibility = 'hidden';
        document.body.appendChild(div);
        const width = div.offsetWidth;
        document.body.removeChild(div);
        return width;
    };

    const getTooltipTile = (items: string[], icons?: string[]) => {
        return (
            <div>
                {items.map((item, index) => (
                    <div className={styles['no-style-item']} style={{ border: 'none' }} key={index}>
                        {(iconName || icons) && iconFirst && <Icon name={icons ? icons[index] : iconName} />}
                        <span>{item}</span>
                        {(iconName || icons) && !iconFirst && <Icon name={icons ? icons[index] : iconName} />}
                    </div>
                ))}
            </div>
        );
    };

    const handleResize = () => {
        if (parentRef.current) {
            let totalWidth = 0;
            const renderedItems: JSX.Element[] = [];
            itemsText.forEach((item, index) => {
                const itemWidth = getItemWidth(item);
                const iconWidth = iconName || icons ? 45 : withBorder ? 20 : 15;
                const marginWidth = 8;
                const remainingCountWidth = getItemWidth(` + ${itemsText.length - (renderedItems.length + 1)}`);
                const totalItemWidth = itemWidth + iconWidth;
                if (totalWidth + totalItemWidth + marginWidth + remainingCountWidth <= parentRef.current!.offsetWidth) {
                    renderedItems.push(
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                fontSize,
                                color: colors ? colors?.[index] : fontColor,
                                padding: padding ? padding : undefined,
                                ...itemStyle
                            }}
                            className={
                                noStyle
                                    ? styles['no-style-item']
                                    : withBorder
                                    ? styles['item-border']
                                    : styles['non-border-item']
                            }
                        >
                            {(iconName || icons) && iconFirst && <Icon name={icons ? icons[index] : iconName} />}
                            <span>{item}</span>
                            {(iconName || icons) && !iconFirst && <Icon name={icons ? icons[index] : iconName} />}
                        </div>
                    );
                    totalWidth += totalItemWidth + marginWidth;
                } else {
                    return;
                }
            });
            if (renderedItems.length < itemsText.length) {
                if (renderedItems.length === 0) {
                    renderedItems.push(
                        <div
                            key={1}
                            style={{
                                alignItems: 'center',
                                gap: '5px',
                                fontSize,
                                color: colors ? colors?.[0] : fontColor,
                                padding: padding ? padding : undefined,
                                display: 'flex',
                                ...itemStyle
                            }}
                            className={
                                noStyle
                                    ? styles['no-style-item']
                                    : withBorder
                                    ? styles['item-border']
                                    : styles['non-border-item']
                            }
                        >
                            {(iconName || icons) && iconFirst && <Icon name={icons ? icons[0] : iconName} />}
                            <span
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: parentRef.current.clientWidth - 50,
                                    display: 'inline-block',
                                    textOverflow: 'ellipsis',
                                    ...itemTitleStyle
                                }}
                            >
                                {itemsText[0]}
                            </span>
                            {(iconName || icons) && !iconFirst && <Icon name={icons ? icons[0] : iconName} />}
                        </div>
                    );
                }
                if (renderedItems.length < itemsText.length) {
                    renderedItems.push(
                        <div>
                            <Tooltip
                                type={tooltipType}
                                placement="top"
                                title={
                                    iconsInTooltip && !isListTooltip ? (
                                        getTooltipTile(
                                            itemsText.slice(renderedItems.length),
                                            icons?.slice(renderedItems.length)
                                        )
                                    ) : isListTooltip ? (
                                        <div className={styles['list-tooltip-container']}>
                                            {itemsText.map((cc, index) => {
                                                return (
                                                    <div className={styles.item} key={index}>
                                                        <span className={styles.index}>{index + 1}. </span>
                                                        <span className={styles.title}>{cc}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        itemsText.slice(renderedItems.length).join(', ')
                                    )
                                }
                            >
                                <div
                                    key="remaining"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        width: 'auto',
                                        color: moreColor
                                    }}
                                    className={styles.more}
                                >
                                    + {itemsText.length - renderedItems.length}
                                </div>
                            </Tooltip>
                        </div>
                    );
                }
            }
            setRenderedItems(renderedItems);
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [itemsText, iconName, withBorder, width, colors]);

    return (
        <div style={{ display: 'flex', width }} ref={parentRef} className={styles['chips-wrapper']}>
            {renderedItems}
        </div>
    );
};

export default ChipsWrapper;

export interface ChipsWrapperProps {
    itemsText: string[];
    itemsTextAndIcon?: { text: string; icon: string }[];
    colors?: string[];
    icons?: string[];
    iconName?: string;
    withBorder?: boolean;
    width?: string;
    moreColor?: string;
    fontSize?: string;
    fontColor?: string;
    noStyle?: boolean;
    iconFirst?: boolean;
    iconsInTooltip?: boolean;
    padding?: string;
    isListTooltip?: boolean;
    itemStyle?: object;
    itemTitleStyle?: object;
    tooltipType?: 'primary' | 'secondary';
}
